"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DropdownIcon_1 = __importDefault(require("./icons/DropdownIcon"));
const LogoutIcon_1 = __importDefault(require("./icons/LogoutIcon"));
const MyProfileIcon_1 = __importDefault(require("./icons/MyProfileIcon"));
const NotificationIcon_1 = __importDefault(require("./icons/NotificationIcon"));
const react_1 = __importDefault(require("react"));
const roles_connector_1 = __importDefault(require("@sportnet/roles-connector"));
const meAppSpaces_1 = __importDefault(require("@sportnet/auth/api/meAppSpaces"));
const meUnreadMessagesCount_1 = __importDefault(require("@sportnet/auth/api/meUnreadMessagesCount"));
const styled_components_1 = __importDefault(require("styled-components"));
const SearchBar_1 = __importDefault(require("./components/SearchBar"));
const PpoListItem_1 = __importDefault(require("./components/PpoListItem"));
const polished_1 = require("polished");
const mb_1 = __importDefault(require("../utilities/mb"));
const AuthProvider_1 = require("../AuthProvider");
const Wrapper = styled_components_1.default.div `
  background-color: rgb(236, 239, 240);
  min-height: 100%;
  padding: ${(0, polished_1.rem)(24)};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: ${(0, polished_1.rem)(24)};
`;
const Header = styled_components_1.default.div `
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column-reverse;
  gap: ${(0, polished_1.rem)(24)};

  > div {
    box-shadow: rgba(0, 0, 0, 0.04) 0 ${(0, polished_1.rem)(2)} ${(0, polished_1.rem)(16)};
    box-sizing: border-box;
    height: ${(0, polished_1.rem)(64)};
    gap: ${(0, polished_1.rem)(16)};
    width: 100%;
    border-radius: ${(0, polished_1.rem)(16)};
    background-color: white;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    min-width: none;
    position: relative;
    padding: ${(0, polished_1.rem)(8)} ${(0, polished_1.rem)(16)};
  }

  ${(0, mb_1.default)('xs')} {
    flex-direction: row;
    > div {
      width: fit-content;
    }
  }
`;
const HeaderImageWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;

  > * {
    width: ${(0, polished_1.rem)(32)};
    height: ${(0, polished_1.rem)(32)};
  }
`;
const RoundedImg = styled_components_1.default.img `
  border-radius: 100%;
`;
const TitleWrapper = styled_components_1.default.div `
  display: flex;
  gap: ${(0, polished_1.rem)(4)};
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  > h3 {
    margin: 0;
    font-size: 1em;
    font-weight: 500;
  }

  > h4 {
    margin: 0;
    color: #969696;
    font-size: ${(0, polished_1.em)(12)};
    font-weight: 400;
  }
`;
const NoResults = styled_components_1.default.span `
  color: #bbb;
`;
const DropdownButtonWrapper = styled_components_1.default.div `
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  fill: ${({ $active }) => ($active ? '#5283e7' : '#a7a7a7')};
  transition: 0.15s ease all;

  &:hover {
    fill: rgba(82, 131, 231, 0.75);
  }
`;
const NotificationsCount = styled_components_1.default.span `
  border-radius: 100%;
  position: absolute;
  width: ${(0, polished_1.rem)(16)};
  height: ${(0, polished_1.rem)(16)};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${(0, polished_1.rem)(8)};
  border-radius: 100%;
  color: white;
  background-color: #f92539;
  top: ${(0, polished_1.rem)(2)};
  right: ${(0, polished_1.rem)(2)};
`;
const MyProfileDropdown = styled_components_1.default.div `
  z-index: 2;
  position: absolute;
  border: ${(0, polished_1.rem)(1)} solid rgb(187, 187, 187);
  border-radius: ${(0, polished_1.rem)(16)};
  box-shadow: rgba(0, 0, 0, 0.16) 0px 2px 4px;
  background-color: white;
  margin-top: ${(0, polished_1.rem)(16)};
  padding: ${(0, polished_1.rem)(16)} 0;
  min-width: ${(0, polished_1.rem)(256)};
  right: 0;
  top: ${(0, polished_1.rem)(64)};
  color: black;

  > div {
    font-size: ${(0, polished_1.em)(13.6)};
    font-weight: 500;
    padding: ${(0, polished_1.rem)(12)} ${(0, polished_1.rem)(24)};
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: ${(0, polished_1.rem)(8)};
    color: black;

    &:hover {
      color: #f92539;
      fill: #f92539;
      background-color: rgb(254, 245, 247);
    }
  }
`;
const AppsDropdown = styled_components_1.default.div `
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: ${(0, polished_1.rem)(16)};
  z-index: 2;
  position: absolute;
  border: ${(0, polished_1.rem)(1)} solid rgb(187, 187, 187);
  border-radius: ${(0, polished_1.rem)(16)};
  box-shadow: rgba(0, 0, 0, 0.16) 0 ${(0, polished_1.rem)(2)} ${(0, polished_1.rem)(4)};
  background-color: white;
  margin-top: ${(0, polished_1.rem)(16)};
  padding: ${(0, polished_1.rem)(16)};
  width: fit-content;
  right: 0;
  top: ${(0, polished_1.rem)(64)};
  left: 0;
  max-height: ${(0, polished_1.rem)(310)};
  overflow-y: auto;
  color: black;

  > a {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    border-radius: ${(0, polished_1.rem)(8)};
    gap: ${(0, polished_1.rem)(4)};
    padding: ${(0, polished_1.rem)(8)};
    color: black;
    font-size: ${(0, polished_1.rem)(14)};
    font-weight: normal;

    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }
  }
`;
const AppSpaces = styled_components_1.default.div `
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: ${(0, polished_1.rem)(24)};

  ${(0, mb_1.default)('m')} {
    grid-template-columns: 1fr 1fr;
  }

  ${(0, mb_1.default)(2000)} {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;
const PpoSelector = ({ onSelectAppspace }) => {
    var _a, _b, _c, _d, _e, _f;
    const [q, setQ] = react_1.default.useState('');
    const [fetchingPpos, setFetchingPpos] = react_1.default.useState(false);
    const [fetchingMorePpos, setFetchingMorePpos] = react_1.default.useState(false);
    const [ppos, setPpos] = react_1.default.useState([]);
    const [filteredPpos, setFilteredPpos] = react_1.default.useState([]);
    const [notificationCount, setNotificationCount] = react_1.default.useState(null);
    const [isProfileMenuOpen, setIsProfileMenuOpen] = react_1.default.useState(false);
    const [isAppsMenuOpen, setIsAppsMenuOpen] = react_1.default.useState(false);
    const [apps, setApps] = react_1.default.useState([]);
    const [currentApp, setCurrentApp] = react_1.default.useState({});
    const [activePpo, setActivePpo] = react_1.default.useState({});
    const [isRolesManagerOpened, setIsRolesManagerOpened] = react_1.default.useState(false);
    const debounceRef = react_1.default.useRef(null);
    const [admin, setAdmin] = react_1.default.useState(false);
    const { authUser, accessToken, authState, logout, app: appId } = (0, AuthProvider_1.useAuth)();
    const removeAccents = (text) => {
        return text
            .toLowerCase()
            .replace(/[áàãâä]/gi, 'a')
            .replace(/[čç]/gi, 'c')
            .replace(/[ď]/gi, 'd')
            .replace(/[éèê]/gi, 'e')
            .replace(/[íìïî]/gi, 'i')
            .replace(/[ľĺ]/gi, 'l')
            .replace(/[ñň]/gi, 'n')
            .replace(/[óòöôõ]/gi, 'o')
            .replace(/[řŕ]/gi, 'r')
            .replace(/[š]/gi, 's')
            .replace(/[ť]/gi, 't')
            .replace(/[úùüûů]/gi, 'u')
            .replace(/[ý]/gi, 'y')
            .replace(/[ž]/gi, 'z')
            .replace(/[^a-zA-Z0-9]/g, ' ');
    };
    const filterPpos = react_1.default.useCallback((query) => __awaiter(void 0, void 0, void 0, function* () {
        const searchQueryWithoutAccents = removeAccents(query || '');
        if (!query) {
            setFilteredPpos(ppos);
        }
        else if (admin) {
            setFetchingMorePpos(true);
            yield fetch(`https://api.sportnet.online/v1/ppo?q=${searchQueryWithoutAccents}`)
                .then((res) => res.json())
                .then(({ items = [] }) => {
                setFilteredPpos(items === null || items === void 0 ? void 0 : items.map((e) => {
                    const existing = ppos.find((a) => a.ppo === e._id);
                    return (existing || {
                        ppo: e._id || '',
                        organizationProfileName: e.name || '',
                        organizationName: e.organization_name || '',
                        logo: e.logo_public_url || '',
                        role: 'admin',
                    });
                }));
            })
                .finally(() => {
                setFetchingMorePpos(false);
            });
        }
        else {
            setFilteredPpos(ppos.filter((a) => {
                const orgProfileId = a.ppo;
                const profileName = a.organizationProfileName || '';
                const organizationName = a.organizationName || '';
                return (removeAccents(orgProfileId).includes(searchQueryWithoutAccents) ||
                    removeAccents(profileName).includes(searchQueryWithoutAccents) ||
                    removeAccents(organizationName).includes(searchQueryWithoutAccents));
            }));
        }
    }), [ppos]);
    const fetchPpos = react_1.default.useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        setFetchingPpos(true);
        try {
            const ppos = yield (0, meAppSpaces_1.default)(accessToken || '');
            setAdmin(ppos.some((a) => {
                var _a, _b;
                return ((_a = a.app) === null || _a === void 0 ? void 0 : _a._id) === 'admin' &&
                    ((_b = a.appSpaces) === null || _b === void 0 ? void 0 : _b.some((a) => a.ppo === 'sportnet' && a.role === 'admin'));
            }));
            const newApps = (ppos || []).map((a) => {
                var _a, _b, _c;
                return ({
                    name: (_a = a === null || a === void 0 ? void 0 : a.app) === null || _a === void 0 ? void 0 : _a.name,
                    logo: (_b = a.app) === null || _b === void 0 ? void 0 : _b.logo,
                    url: (_c = a.app) === null || _c === void 0 ? void 0 : _c.url,
                });
            });
            setApps(newApps);
            const appObj = (ppos || []).find((a) => { var _a; return ((_a = a.app) === null || _a === void 0 ? void 0 : _a._id) === appId; });
            setCurrentApp(appObj);
            if (appObj) {
                setPpos((appObj.appSpaces || []));
                setFilteredPpos((appObj.appSpaces || []));
            }
        }
        catch (e) {
            console.error(e);
        }
        finally {
            setFetchingPpos(false);
        }
    }), [appId, accessToken]);
    const updateNotificationCount = react_1.default.useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const unreadMessages = yield (0, meUnreadMessagesCount_1.default)(accessToken || '');
            setNotificationCount(unreadMessages);
        }
        catch (e) {
            console.error(e);
        }
    }), [accessToken]);
    react_1.default.useEffect(() => {
        if (authState === 'authorized') {
            fetchPpos();
            updateNotificationCount();
        }
    }, [authState, fetchPpos, updateNotificationCount]);
    const closeRolesManager = react_1.default.useCallback(() => {
        setIsRolesManagerOpened(false);
        setActivePpo(null);
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(roles_connector_1.default, { opened: isRolesManagerOpened, appSpace: activePpo || '', appId: appId, accessToken: accessToken || '', onClose: closeRolesManager, onError: (e) => {
                closeRolesManager();
                throw e;
            }, onUnauthorized: () => {
                closeRolesManager();
                throw Error('Neautorizovaný pre správu používateľov');
            } }),
        react_1.default.createElement(Wrapper, { className: "wrapper", onClick: () => {
                setIsProfileMenuOpen(false);
                setIsAppsMenuOpen(false);
            } }, authState === 'authorized' ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Header, null,
                react_1.default.createElement("div", { onClick: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setIsProfileMenuOpen(false);
                        setIsAppsMenuOpen((prev) => !prev);
                    } },
                    fetchingPpos ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(HeaderImageWrapper, null,
                            react_1.default.createElement("div", null)),
                        react_1.default.createElement(TitleWrapper, null,
                            react_1.default.createElement("h3", { style: { color: '#bbb' } }, "Loading...")))) : (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(HeaderImageWrapper, null,
                            react_1.default.createElement(RoundedImg, { src: (_a = currentApp === null || currentApp === void 0 ? void 0 : currentApp.app) === null || _a === void 0 ? void 0 : _a.logo, width: 32, height: 32, alt: "profile-pic" })),
                        react_1.default.createElement(TitleWrapper, null,
                            react_1.default.createElement("h3", null, (_b = currentApp === null || currentApp === void 0 ? void 0 : currentApp.app) === null || _b === void 0 ? void 0 : _b.name)))),
                    react_1.default.createElement(DropdownButtonWrapper, null,
                        react_1.default.createElement(DropdownIcon_1.default, null)),
                    isAppsMenuOpen && (react_1.default.createElement(AppsDropdown, null, apps.map((app, idx) => (react_1.default.createElement("a", { key: idx, href: app.url || '', onClick: (e) => {
                            e.stopPropagation();
                        } },
                        react_1.default.createElement(RoundedImg, { src: (app === null || app === void 0 ? void 0 : app.logo) || '', width: 32, height: 32, alt: "app-logo" }),
                        react_1.default.createElement("span", null, app.name))))))),
                react_1.default.createElement("div", { onClick: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setIsAppsMenuOpen(false);
                        setIsProfileMenuOpen((prev) => !prev);
                    } },
                    react_1.default.createElement(DropdownButtonWrapper, { "$active": !!notificationCount && notificationCount > 0, onClick: (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setIsAppsMenuOpen(false);
                            setIsProfileMenuOpen(false);
                            window.open('https://my.sportnet.online/messages');
                        } },
                        !!notificationCount && notificationCount > 0 && (react_1.default.createElement(NotificationsCount, null, notificationCount > 99 ? '99+' : notificationCount)),
                        react_1.default.createElement(NotificationIcon_1.default, { active: !!notificationCount && notificationCount > 0 })),
                    react_1.default.createElement(TitleWrapper, null,
                        react_1.default.createElement("h3", null, `${(_c = authUser === null || authUser === void 0 ? void 0 : authUser.name) !== null && _c !== void 0 ? _c : ''} ${(_d = authUser === null || authUser === void 0 ? void 0 : authUser.surname) !== null && _d !== void 0 ? _d : ''}`),
                        !!((_e = authUser === null || authUser === void 0 ? void 0 : authUser.appSpace) === null || _e === void 0 ? void 0 : _e.roles) &&
                            ((_f = authUser === null || authUser === void 0 ? void 0 : authUser.appSpace) === null || _f === void 0 ? void 0 : _f.roles[appId]) && (react_1.default.createElement("h4", null, `${authUser.appSpace.roles[appId]}`))),
                    react_1.default.createElement(RoundedImg, { src: authUser === null || authUser === void 0 ? void 0 : authUser.photoUrl, width: 48, height: 48, alt: "profile-pic" }),
                    isProfileMenuOpen && (react_1.default.createElement(MyProfileDropdown, null,
                        react_1.default.createElement("div", { onClick: (e) => {
                                e.stopPropagation();
                                setIsProfileMenuOpen(false);
                                window.open('https://my.sportnet.online/profile/personal-info');
                            } },
                            react_1.default.createElement(MyProfileIcon_1.default, null),
                            react_1.default.createElement("span", null, "M\u00F4j Profil")),
                        react_1.default.createElement("div", { onClick: () => {
                                logout();
                            } },
                            react_1.default.createElement(LogoutIcon_1.default, null),
                            react_1.default.createElement("span", null, "Odhl\u00E1si\u0165 sa")))))),
            react_1.default.createElement(SearchBar_1.default, { value: q, loading: fetchingMorePpos, onChange: (value) => {
                    if (debounceRef.current) {
                        clearTimeout(debounceRef.current);
                    }
                    const currentQuery = value || '';
                    setQ(currentQuery);
                    debounceRef.current = setTimeout(() => {
                        filterPpos(currentQuery);
                    }, admin ? 400 : 0);
                } }),
            fetchingPpos ? (react_1.default.createElement(NoResults, null, "Loading...")) : (react_1.default.createElement(AppSpaces, null,
                filteredPpos.map((ppo, idx) => (react_1.default.createElement(PpoListItem_1.default, { key: idx, onClick: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        !!onSelectAppspace && onSelectAppspace(ppo);
                    }, ppo: ppo, onOpenRolesManager: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setActivePpo(ppo.ppo);
                        setIsRolesManagerOpened(true);
                    } }))),
                (filteredPpos === null || filteredPpos === void 0 ? void 0 : filteredPpos.length) === 0 && (react_1.default.createElement(NoResults, null, "\u017Diadne v\u00FDsledky")))))) : (react_1.default.createElement(react_1.default.Fragment, null, "loading...")))));
};
exports.default = PpoSelector;
